import { render, staticRenderFns } from "./FaqPage.vue?vue&type=template&id=6faa5c74"
import script from "./FaqPage.vue?vue&type=script&lang=ts"
export * from "./FaqPage.vue?vue&type=script&lang=ts"
import style0 from "./FaqPage.vue?vue&type=style&index=0&id=6faa5c74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports